import { initializeAppearance } from "@web/theme/appearance";
import React from "react";
import ReactDOM from "react-dom/client";
import { AppWithProviders } from "@app/App";

initializeAppearance();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppWithProviders />
  </React.StrictMode>,
);
